// extracted by mini-css-extract-plugin
module.exports = {"payment-redirect":"PaymentRedirect_payment-redirect__Pap3y","icon":"PaymentRedirect_icon__joeGh","desc":"PaymentRedirect_desc__3qtvj"};